import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SimpleForm, useNotify, useRedirect } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';
import { Referral } from 'types/embedded/referral';

import { ReferralsForm } from './components/ReferralsFrom';

export const ReferralsCreate: React.FC = () => {
  const translate = useTypedTranslate();

  const notify = useNotify();
  const redirect = useRedirect();

  function onSuccess(referral: Referral) {
    notify(
      <>
        Реферал <TypographyBold text={referral.name} /> создан
      </>,
      { type: 'success' },
    );
    redirect('list', Resources.Referrals);
  }

  function onError(error: any) {
    notify(error.message, { type: 'error' });
  }

  return (
    <CreatePage
      listName={translate('app.referrals.title')}
      mutationOptions={{ onSuccess, onError }}
      title={translate('app.referrals.createTitle')}
    >
      <SimpleForm sx={{ '&.MuiCardContent-root': { padding: 0 } }} toolbar={false}>
        <ReferralsForm />
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" variant="outlined" />,
            <SaveButtonValidated key="save-button" label={translate('app.buttons.create')} />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
    </CreatePage>
  );
};
